import React, { useEffect, useState, useRef, useMemo } from 'react'
import {
  makeStyles,
  createStyles,
  Box,
  Typography,
  fade,
  Divider,
  Button,
  useTheme,
  useMediaQuery,
} from '@material-ui/core'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import { withStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useParams, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getTestCenterInfo, setSelectedDoctor } from 'src/store/slices/testCenterSlice'
import { useCustomTranslation, useAddressFormat, useDateFnsLocale } from 'src/hooks'
import useUserSession from 'src/hooks/useUserSession'
import FormatWeekAvailableDate from 'src/mobile/components/FormatWeekAvailableDate'
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper/core'
import 'swiper/swiper-bundle.min.css'
import 'swiper/components/pagination/pagination.min.css'
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/autoplay'
import InfoWrapper from 'src/mobile/components/InfoWrapper'
import { MOBILE_HEADER_HEIGHT, DAY_SEGMENTS } from 'src/mobile/utils/constant'
import Loading from 'src/mobile/components/Loading'
import { useTranslation } from 'react-i18next'
import { translateRegion } from 'src/utils'
import BookingCard from 'src/mobile/components/DoctorDetail/BookingCard'
import ScheduleDrawer from 'src/mobile/components/DoctorDetail/ScheduleDrawer'
// import useAuthRedirect from 'src/hooks/useAuthRedirect'
import { getTimeSlices, getFormatAvlObj } from 'src/mobile/utils'
import { getDoctorBookings } from 'src/store/slices/userSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import subDays from 'date-fns/subDays'
import DateRangeIcon from '@material-ui/icons/DateRange'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import { DATE_FORMAT, DAY_OF_WEEK, LATER_DISABLE_DAYS, AVAILABLE_MONTHS } from 'src/utils/constant'
import subMonths from 'date-fns/subMonths'
import eachDayOfInterval from 'date-fns/eachDayOfInterval'
import format from 'date-fns/format'
import { groupBy } from 'lodash'
import { HK_HOLIDAYS } from 'src/utils/hkHolidays'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FixedButtonWrapper from 'src/mobile/components/FixedButtonWrapper'
import DetailModal from 'src/mobile/components/DetailModal'
import ClinicStep from 'src/mobile/components/ClinicStep'
import GoogleMap from '../components/GoogleMap'
import MapOutlinedIcon from '@material-ui/icons/MapOutlined'
SwiperCore.use([Autoplay, Pagination, Navigation])
const Accordion = withStyles({
  root: {
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgb(243, 244, 246)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    // borderBottomRightRadius: '24px',
    // borderBottomLeftRadius: '24px',
    '&$expanded': {
      minHeight: 56,
      borderBottomRightRadius: '0',
      borderBottomLeftRadius: '0',
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
  root: {
    backgroundColor: 'rgb(243, 244, 246)',
    padding: theme.spacing(2),
    borderBottomRightRadius: '24px',
    borderBottomLeftRadius: '24px',
  },
}))(MuiAccordionDetails)
const useStyles = makeStyles((theme) =>
  createStyles({
    sidebarTank: {
      width: theme.spacing(40),
      flexShrink: 0,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingTop: theme.spacing(4),
      backgroundColor: '#fff',
    },
    sidebarContent: {
      flexGrow: 1,
      padding: 0,
      maxWidth: theme.spacing(150),
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(5),
      paddingRight: '106px',
      backgroundColor: '#fff',

      borderLeft: '1px solid #E5E7EB',
      [theme.breakpoints.down('md')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    },
    doctor: {
      border: ' 1px solid #E5E7EB',
      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08), 0px 1px 1px rgba(0, 0, 0, 0.08)',
      borderRadius: '24px',
      padding: theme.spacing(3, 2),
      [theme.breakpoints.down('xs')]: {
        border: 'none',
        boxShadow: 'none',
        padding: 0,
        marginBottom: theme.spacing(4),
      },
    },
    flexLayout: {
      display: 'flex',
      backgroundColor: '#fff',
      // [theme.breakpoints.down('md')]: {
      //   margin: theme.spacing(0, 0),
      //   paddingTop: theme.spacing(MOBILE_HEADER_HEIGHT + 2),
      // },
    },
    muiFormGroup: {
      flexDirection: 'row',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
    appBar: {
      top: theme.spacing(MOBILE_HEADER_HEIGHT),
    },
    container: {
      background: '#fff',
    },
    heading: {
      fontSize: '16px',
      fontWeight: 600,
    },
    topCard: {
      borderTopRightRadius: '24px',
      borderTopLeftRadius: '24px',
    },
    swiper: {
      height: '100%',
      '& .swiper-slide': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    icon: {
      flexShrink: 0,
      width: theme.spacing(3),
      height: theme.spacing(3),
      '& path': {
        width: theme.spacing(1.75),
        height: theme.spacing(1.75),
        fill: theme.palette.grey[800],
      },
    },
    secondaryIcon: {
      '& path': {
        fill: theme.palette.secondary.main,
      },
    },
    location: {
      boxShadow: `-0.5px 0 0 0 ${theme.palette.grey[50]}`,
    },
    imageFillIcon: {
      width: theme.spacing(5),
      height: theme.spacing(5),
      '& path': {
        fill: theme.palette.grey[100],
      },
    },
    cover: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    radio: {
      position: 'absolute',
      top: 10,
      right: 20,
    },
    radioPc: {
      left: 360,
      bottom: 40,
    },
    markButton: {
      backgroundColor: fade(theme.palette.secondary.main, 0.1),
    },
    datePickerLoading: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255,255,255,0.8)',
      zIndex: 1,
      display: 'flex',
      justifyContent: 'center',
    },
    field: {
      width: '100%',
    },
  }),
)

const ClinicDetail = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { id } = useParams()
  // const authRedirect = useAuthRedirect()
  const [expanded, setExpanded] = React.useState(false)
  const theme = useTheme()

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const { weekDaysArray } = useDateFnsLocale()
  const { t } = useTranslation()
  const [tB] = useCustomTranslation()
  const { addressFormat } = useAddressFormat()
  const {
    currentTestCenter: clinic,
    testCenterInfoStatus,
    doctorList,
    clinicDoctorList,
  } = useSelector((state) => state.testCenter)
  const { authenticated } = useUserSession()
  useEffect(() => {
    dispatch(getTestCenterInfo({ id: Number(id) }))
  }, [])

  const { selectedDoctor } = useSelector((state) => state.testCenter)
  const avlDaysRef = useRef(null)
  const [baseInfo, setBaseInfo] = useState(null)
  const [clinicList, setClinicList] = useState([])
  const { bookingsStatus } = useSelector((state) => state.user)
  const [newList, setNewList] = useState([])
  // const [value, setValue] = useState(1)
  const [bookings, setBookings] = useState(null)
  const [step, setStep] = useState(1)
  const [selectedTime, setSelectedTime] = useState(null)
  const history = useHistory()
  const [selectedSegment, setSelectedSegment] = useState(null)
  // const handleChange = (e, newValue) => setValue(newValue)
  useEffect(async () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    if (clinicDoctorList?.length > 0) {
      let doctorId = []
      let allBookings = null
      for (let i = 0; i < clinicDoctorList?.length; i++) {
        doctorId.push(clinicDoctorList[i]?.id)
      }
      try {
        const res = await dispatch(
          getDoctorBookings({
            doctorId: doctorId,
            testCenterId: Number(clinic?.id),
          }),
        )
        allBookings = unwrapResult(res)
      } catch (error) {
        console.log('Get all booking fail:', error)
      }
      setBookings(allBookings)
    }
  }, [clinicDoctorList])
  useEffect(async () => {
    const { ...rest } = clinic
    let _doctorList = doctorList.filter((item) => item.package.indexOf(selectedDoctor?.package) !== -1)
    if (_doctorList.length > 0) {
      let availableTimeListMerge = []
      for (let i = 0; i < _doctorList.length; i++) {
        availableTimeListMerge.push(
          _doctorList[i]?.availableTimeList?.find((item) => item.testCenterId === Number(id)),
        )
      }

      let notAvailableTimeListMerge = []
      for (let i = 0; i < _doctorList.length; i++) {
        notAvailableTimeListMerge.push(..._doctorList[i].notAvailableTimeList)
      }
      // let sameItems = notAvailableTimeListMerge
      //   .filter(
      //     (item, index) =>
      //       notAvailableTimeListMerge.findIndex(
      //         (findItem) =>
      //           findItem.clinicId === item.clinicId &&
      //           findItem.schedule === item.schedule &&
      //           findItem.date === item.date,
      //       ) !== index,
      //   )
      //   .reduce((acc, cur) => {
      //     if (
      //       !acc.some(
      //         (item) =>
      //           item.clinicId === cur.clinicId && item.schedule === cur.schedule && item.date === cur.date,
      //       )
      //     ) {
      //       acc.push(cur)
      //     }
      //     return acc
      //   }, [])

      const { testCenterName } = _doctorList[0]
      setBaseInfo(rest)
      // 拿到可以预约诊所列表
      const avlClinicList =
        availableTimeListMerge
          ?.map((item) => {
            const clinicItem = testCenterName?.find(
              (clinic) => clinic.clinicType === 1 && clinic.status && Number(clinic.id) === Number(id),
            )
            const notAvlTimeList = notAvailableTimeListMerge.filter(
              (item) => item.ClinicDetail === Number(id),
            )
            return clinicItem
              ? {
                  avlDoctorInfo: item,
                  avlClinicInfo: clinicItem,
                  // 确保诊所只有一个医生在线时 停诊某一天的话可以让日历不亮起来，多个医生则会亮 但是有文案提示
                  notAvlTimeList: _doctorList?.length === 1 ? notAvlTimeList : [],
                }
              : null
          })
          .filter((item) => item) || []

      // 获取当天停班时间表
      const getNotAvlSchedule = (notAvlItem) => {
        let notAvlSchedule = []

        notAvlItem?.schedule?.split(',')?.forEach((time) => {
          notAvlSchedule = notAvlSchedule.concat(getTimeSlices(time))
        })
        return notAvlSchedule || []
      }
      if (avlClinicList?.length) {
        let list = []
        let dayList = []
        await Promise.all(
          avlClinicList.map(async (clinic, index) => {
            const { avlDoctorInfo, avlClinicInfo, notAvlTimeList } = clinic
            // let allBookings = null
            // try {
            //   const res = await dispatch(
            //     getAllBookings({
            //       testCenterId: Number(avlDoctorInfo.testCenterId),
            //     }),
            //   )
            //   allBookings = unwrapResult(res)
            // } catch (error) {
            //   console.log('Get all booking fail:', error)
            // }
            const formatAvlObj = getFormatAvlObj(avlDoctorInfo, avlClinicInfo)
            const getMaxAvlDays = () => {
              const startDay = subDays(new Date(), avlDoctorInfo?.isSpecial ? -7 : -LATER_DISABLE_DAYS)
              const endDay = subMonths(new Date(), -AVAILABLE_MONTHS)
              return eachDayOfInterval({ start: startDay, end: endDay }) || []
            }
            // 按每周上班日期 及 是否有上班时间表 筛选日期
            let days = getMaxAvlDays()
              ?.map((day) => {
                // 获取当天时间表
                const formatDay = format(day, DATE_FORMAT)
                const avlSlices = formatAvlObj?.[format(day, DAY_OF_WEEK)]
                const notAvlItem = notAvlTimeList?.find((item) => item.date === format(day, DATE_FORMAT))
                const notAvlSlices = getNotAvlSchedule(notAvlItem)
                // 出诊的时间表
                const schedule = notAvlSlices?.length
                  ? avlSlices?.filter(
                      (avlSlice) =>
                        !notAvlSlices?.find((notAvlSlice) => notAvlSlice?.value === avlSlice?.value),
                    )
                  : avlSlices
                if (!schedule?.length) return null

                // const bookings = allBookings?.[formatDay]

                const finalSchedule = schedule?.map((item) => {
                  return {
                    ...item,
                    // bookingCount: bookings?.[item.value] ? Number(bookings?.[item.value]) : 0,
                  }
                })

                const daySegmentGroup = groupBy(finalSchedule, 'daySegment')

                const status = DAY_SEGMENTS?.map((segment, index) => {
                  let status = 0
                  const list = daySegmentGroup?.[index]
                  if (list) {
                    status = list?.find((item) => item.bookingCount < 2) ? 1 : 2
                  }
                  return status
                })

                return {
                  day: formatDay,
                  schedule: finalSchedule,
                  status,
                }
              })
              ?.filter((obj) => obj)
            // 根据诊所及医生节假日上班情况展示日历可预约时间
            if (avlClinicInfo?.holiday || avlDoctorInfo?.holiday)
              days = days.filter((obj) => obj.day !== HK_HOLIDAYS.find((day) => day === obj.day))
            list.push({
              ...avlClinicInfo,
              avlDoctorInfo,
              avlDays: days?.map((obj) => {
                return {
                  day: obj.day,
                  status: obj.status,
                }
              }),
              isSpecial: avlDoctorInfo?.isSpecial,
              packages: avlDoctorInfo?.package,
            })
            dayList.push(days)
            avlDaysRef.current = {
              ...avlDaysRef.current,
              [avlDoctorInfo?.testCenterId]: {
                ...avlClinicInfo,
                avlDays: days,
                isSpecial: avlDoctorInfo?.isSpecial,
                packages: avlDoctorInfo?.package,
              },
            }
          }),
        )

        let arr = []
        dayList?.forEach((item, index) => {
          item.forEach((x) => {
            arr.push(x)
          })
        })
        avlDaysRef.current = {
          [id]: {
            avlDays: arr,
          },
        }
        // 需要合并
        let newArr = []
        for (let i = 0; i < list.length; i++) {
          newArr.push(...list[i].avlDays)
        }
        setNewList(newArr)
        setClinicList(list)
      }
    }
  }, [doctorList])
  const selectedClinic = useMemo(() => {
    if (!selectedSegment) return null
    const avlDays = avlDaysRef?.current?.[Number(id)]?.avlDays
    const avlItem = avlDaysRef?.current?.[Number(id)]
    return {
      ...selectedSegment,
      id: Number(id),
      price: avlItem?.price,
      name: avlItem?.[tB('name')],
      nameCn: avlItem?.nameCn,
      nameEn: avlItem?.nameEn,
      nameHk: avlItem?.nameHk,
      phone: avlItem?.phone,
      lowerPrice: clinic?.lowerPrice,
      higherPrice: clinic?.higherPrice,
      address: addressFormat(clinic?.[tB('address')], t(translateRegion(clinic?.area))),
      isSpecial: clinic?.doctorSpecialCount,
      schedule: avlDays,
    }
  }, [selectedSegment])

  const handleOpenSchedule = (value) => {
    setSelectedSegment({ ...value })
  }
  const [selectDoctor, setDoctor] = useState(null)

  const handleStoreOrder = (value) => {
    if (value?.selectedTime) {
      setSelectedTime(value?.selectedTime)
      setStep(2)
    }
    dispatch(
      setSelectedDoctor({
        ...baseInfo,
        doctorId: selectDoctor,
        appointmentDate: selectedClinic?.day,
        appointmentTime: value?.selectedTime,
        testCenterId: selectedClinic?.id,
        testCenterNameCn: clinic?.nameCn,
        testCenterNameEn: clinic?.nameEn,
        testCenterNameHk: clinic?.nameHk,
        nameCn: doctorList.filter((item) => Number(item.id) === Number(selectDoctor))[0]?.nameCn,
        nameEn: doctorList.filter((item) => Number(item.id) === Number(selectDoctor))[0]?.nameEn,
        nameHk: doctorList.filter((item) => Number(item.id) === Number(selectDoctor))[0]?.nameHk,
        honoraryTitleCn: doctorList.filter((item) => Number(item.id) === Number(selectDoctor))[0]
          ?.honoraryTitleCn,
        honoraryTitleEn: doctorList.filter((item) => Number(item.id) === Number(selectDoctor))[0]
          ?.honoraryTitleEn,
        honoraryTitleHk: doctorList.filter((item) => Number(item.id) === Number(selectDoctor))[0]
          ?.honoraryTitleHk,
        testCenterPhone: selectedClinic?.phone,
        testCenterAddressHk: clinic?.addressHk,
        testCenterAddressEn: clinic?.addressEn,
        testCenterAddressCn: clinic?.addressCn,
        package: selectedDoctor?.package,
        price: selectedDoctor?.price,
        currency: selectedDoctor?.currency,
      }),
    )
    // authRedirect({ redirectUrl: '/add-order' })
  }
  const goOrderDetail = () => {
    dispatch(
      setSelectedDoctor({
        ...baseInfo,
        doctorId: selectDoctor,
        appointmentDate: selectedClinic?.day,
        appointmentTime: selectedTime,
        testCenterId: selectedClinic?.id,
        testCenterNameCn: clinic?.nameCn,
        testCenterNameEn: clinic?.nameEn,
        testCenterNameHk: clinic?.nameHk,
        nameCn: doctorList.filter((item) => Number(item.id) === Number(selectDoctor))[0]?.nameCn,
        nameEn: doctorList.filter((item) => Number(item.id) === Number(selectDoctor))[0]?.nameEn,
        nameHk: doctorList.filter((item) => Number(item.id) === Number(selectDoctor))[0]?.nameHk,
        honoraryTitleCn: doctorList.filter((item) => Number(item.id) === Number(selectDoctor))[0]
          ?.honoraryTitleCn,
        honoraryTitleEn: doctorList.filter((item) => Number(item.id) === Number(selectDoctor))[0]
          ?.honoraryTitleEn,
        honoraryTitleHk: doctorList.filter((item) => Number(item.id) === Number(selectDoctor))[0]
          ?.honoraryTitleHk,
        testCenterPhone: selectedClinic?.phone,
        testCenterAddressHk: clinic?.addressHk,
        testCenterAddressEn: clinic?.addressEn,
        testCenterAddressCn: clinic?.addressCn,
        package: selectedDoctor?.package,
        price: selectedDoctor?.price,
        currency: selectedDoctor?.currency,
      }),
    )
    history.push('/preOrder')
  }
  const handleChangeRadio = (e) => {
    setDoctor(e.target.value)
  }
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  const renderTitle = () => {
    return (
      <Typography variant={isMobile ? 'h4' : 'h6'} noWrap>
        <DetailModal
          value={Number(selectedDoctor?.package)}
          price={Number(selectedDoctor?.price)}
          currency={Number(selectedDoctor?.currency)}
        />
      </Typography>
    )
  }
  const renderButton = () => {
    return (
      <Box
        width="100%"
        display="flex"
        justifyContent={isMobile ? 'space-around' : 'flex-end'}
        position="sticky"
        bottom={1}
        p={isMobile ? 0 : 1}
        bgcolor="#fff"
      >
        <Button
          size="large"
          color="primary"
          style={{
            textDecoration: 'underline',
            color: '#000000',
            fontSize: isMobile ? '16px' : '18px',
            marginRight: isMobile ? 0 : '20px',
          }}
          onClick={() => (!selectedTime ? history.push('/clinic') : setSelectedTime(null))}
        >
          {t('common.back')}
        </Button>

        <Button
          fullWidth={isMobile}
          type="submit"
          style={{ width: !isMobile && '150px', fontSize: isMobile ? '16px' : '18px' }}
          size={isMobile ? 'medium' : 'large'}
          variant="contained"
          color="secondary"
          onClick={goOrderDetail}
          disabled={!selectDoctor || !selectedTime}
        >
          {t('common.go_on')}
        </Button>
      </Box>
    )
  }

  return (
    <>
      {!isMobile && (
        <>
          {renderTitle()}
          <Divider />
        </>
      )}

      <Box className={!isMobile ? classes.flexLayout : {}} minHeight={isMobile ? 500 : 800}>
        {!isMobile && (
          <Box className={classes.sidebarTank}>
            <ClinicStep step={step} />
          </Box>
        )}

        {clinic ? (
          <Box className={isMobile ? classes.container : classes.sidebarContent}>
            <InfoWrapper isBooking>
              {isMobile && renderTitle()}
              <Box className={classes.root} style={{ position: 'relative' }}>
                {!selectedTime ? (
                  <>
                    {newList.length < 1 && (
                      <Box className={classes.datePickerLoading}>
                        <Loading />
                      </Box>
                    )}

                    <BookingCard
                      clinic={clinicList[0]}
                      authenticated={authenticated}
                      onOpenSchedule={handleOpenSchedule}
                      newList={newList}
                      packages={selectedDoctor?.package}
                    />
                  </>
                ) : (
                  // <Box>hello</Box>
                  <Box className={classes.doctor}>
                    {isMobile && <Divider />}{' '}
                    {isMobile && (
                      <Box fontSize={18} fontWeight={600} py={2}>
                        {t('common.select_doctor')}{' '}
                      </Box>
                    )}
                    <Box height="auto" display="flex" justifyContent="center">
                      <FormControl component="fieldset" className={classes.field}>
                        <RadioGroup
                          value={Number(selectDoctor)}
                          onChange={handleChangeRadio}
                          classes={{ root: classes.muiFormGroup }}
                        >
                          {clinicDoctorList?.map((item, index) => (
                            <Box
                              key={index}
                              width={isMobile ? '100%' : 420}
                              height={isMobile ? 132 : 156}
                              boxShadow="0px 2px 6px 3px rgba(34, 34, 34, 0.12)"
                              my={1}
                              pl={4}
                              position="relative"
                              mr={!isMobile && 2}
                              borderRadius={10}
                              display="flex"
                              justifyContent="flex-start"
                              bgcolor={
                                !(
                                  (item.isSpecial ? 1 : 2) -
                                    (bookingsStatus === 'fulfilled' &&
                                    bookings &&
                                    bookings[`${item.id}`] &&
                                    bookings[`${item.id}`][`${selectedClinic?.day}`] &&
                                    bookings[`${item.id}`][`${selectedClinic?.day}`][`${selectedTime}`]
                                      ? bookings[`${item.id}`][`${selectedClinic?.day}`][`${selectedTime}`] ||
                                        0
                                      : 0) >
                                  0
                                )
                                  ? '#f3f4f6'
                                  : ''
                              }
                              border={Number(item.id) === Number(selectDoctor) ? `1px solid #F2512D` : 'none'}
                            >
                              <FormControlLabel
                                value={item.id}
                                classes={{ root: classes.label }}
                                overflow="hidden"
                                control={
                                  <Radio
                                    classes={{ root: isMobile ? classes.radio : classes.radioPc }}
                                    id={item.id}
                                    disabled={
                                      !(
                                        (item.isSpecial ? 1 : 2) -
                                          (bookingsStatus === 'fulfilled' &&
                                          bookings &&
                                          bookings[`${item.id}`] &&
                                          bookings[`${item.id}`][`${selectedClinic?.day}`] &&
                                          bookings[`${item.id}`][`${selectedClinic?.day}`][`${selectedTime}`]
                                            ? bookings[`${item.id}`][`${selectedClinic?.day}`][
                                                `${selectedTime}`
                                              ] || 0
                                            : 0) >
                                        0
                                      )
                                    }
                                  />
                                }
                                label={
                                  <Box ml={authenticated ? 0 : 1}>
                                    <Box
                                      borderRadius={4}
                                      fontSize="18px"
                                      px={0.5}
                                      py={0.5}
                                      flexShrink="0"
                                      id={item.id}
                                    >
                                      <Box fontWeight={700} mb={1}>
                                        {item[tB('name')]}
                                      </Box>
                                      <Box
                                        border="1px solid #D1D5DB"
                                        borderRadius="4px"
                                        height={36}
                                        minWidth={100}
                                        fontSize={14}
                                        fontWeight={400}
                                        lineHeight={2.5}
                                        textAlign="center"
                                      >
                                        {' '}
                                        {item[tB('honoraryTitle')]}
                                      </Box>
                                      <Box color="grey.400" mt={1} fontSize={14}>
                                        {t('form.language')} ：{item[tB('language')]}
                                      </Box>
                                    </Box>
                                  </Box>
                                }
                              />
                            </Box>
                          ))}
                        </RadioGroup>
                      </FormControl>{' '}
                    </Box>
                    {isMobile && <Divider />}
                  </Box>
                )}
              </Box>
              <ScheduleDrawer
                clinic={selectedClinic}
                onStoreOrder={handleStoreOrder}
                price={selectedDoctor?.price}
                currency={selectedDoctor?.currency}
                packages={selectedDoctor?.package}
                authenticated={authenticated}
                selectDoctor={selectDoctor}
              />{' '}
            </InfoWrapper>
            <Box
              borderTop="1px solid #EBEBEC"
              bgcolor="#F3F4F6"
              className={classes.topCard}
              width="100%"
              padding={isMobile ? 3 : 4}
            >
              <Box
                py={2}
                fontWeight={600}
                color="secondary.main"
                fontSize={isMobile ? 16 : 23}
                borderBottom="1px solid #EBEBEC"
              >
                {t('common.site')}{' '}
              </Box>
              <Box display="flex">
                {!isMobile && (
                  <Box mt={isMobile ? 3 : 4} mr={isMobile ? 0 : 4}>
                    <img
                      src={clinic?.cover}
                      style={{ width: '240px', height: '240px', borderRadius: '8px' }}
                    />
                  </Box>
                )}
                <Box>
                  {' '}
                  <Box
                    fontSize={isMobile ? 18 : 20}
                    fontWeight={600}
                    my={1.5}
                    display="flex"
                    justifyContent="space-between"
                  >
                    {clinic?.[tB('name')]}{' '}
                    <GoogleMap
                      lng={clinic?.lng}
                      lat={clinic?.lat}
                      name={clinic[tB('name')]}
                      address={addressFormat(clinic[tB('address')], t(translateRegion(clinic?.area)))}
                      className={classes.googlemap}
                    >
                      <Box display="flex" cursor='pointer'>
                        <MapOutlinedIcon style={{ color: '#24252d' }} />
                        <span
                          style={{
                            fontSize: 16,
                            lineHeight: 1.5,
                            textDecoration: 'underline',
                            color: '#24252d',
                            cursor:'pointer'
                          }}
                        >
                          {t('glossary.map')}
                        </span>
                      </Box>
                    </GoogleMap>
                  </Box>
                  <Box mr="auto" fontSize={16} fontWeight={400} color="#4B5563">
                    {addressFormat(clinic?.[tB('address')], t(translateRegion(clinic?.area)))}
                  </Box>
                  <Box
                    m={0}
                    bgcolor="background.paper"
                    color="grey.800"
                    p={1.5}
                    component="p"
                    whiteSpace="pre-line"
                    borderRadius={8}
                    mt={2}
                  >
                    <Box fontSize={16} fontWeight={600} mb={1}>
                      {t('tips.main_tips')}
                    </Box>
                    <Box fontSize={isMobile ? 14 : 16}> {t('tips.pay_extra')}</Box>
                  </Box>
                  {!isMobile && (
                    <Box>
                      <Box mt={2} borderTop="1px solid #EBEBEC">
                        {' '}
                        <Box className={classes.heading} mt={2}>
                          {t('common.service_time')}
                        </Box>
                      </Box>

                      <Typography>
                        {clinic?.availableTime && (
                          <Box mt={1} color="grey.800" display="flex">
                            <Box>
                              <FormatWeekAvailableDate
                                holiday={clinic?.holiday}
                                availableTime={clinic?.availableTime}
                              />
                            </Box>
                          </Box>
                        )}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
            {isMobile && (
              <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography className={classes.heading}>{t('common.service_time')}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {clinic?.availableTime && (
                      <Box mt={1} color="grey.800" display="flex">
                        <Box>
                          <FormatWeekAvailableDate
                            holiday={clinic?.holiday}
                            availableTime={clinic?.availableTime}
                          />
                        </Box>
                      </Box>
                    )}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            )}
            {selectedTime && (
              <Box
                borderTop="1px solid #EBEBEC"
                bgcolor="#F3F4F6"
                borderRadius={24}
                width="100%"
                padding={2}
                mt={4}
              >
                <Box
                  py={2}
                  fontWeight={600}
                  color="secondary.main"
                  fontSize={isMobile ? 16 : 23}
                  borderBottom="1px solid #EBEBEC"
                >
                  {t('common.service_timeAndDate')}
                </Box>
                <Box mt={1.5} display="flex" alignItems="center">
                  <DateRangeIcon />
                  <Box ml={1} fontSize={isMobile ? 16 : 20} fontWeight={600}>
                    {selectedClinic?.day} {weekDaysArray()[selectedClinic?.week]}
                  </Box>
                </Box>
                <Box mt={isMobile ? 2 : 3} display="flex" alignItems="center">
                  <AccessTimeIcon />
                  <Box ml={1} fontSize={isMobile ? 16 : 20} fontWeight={600}>
                    {selectedTime}{' '}
                  </Box>
                </Box>
              </Box>
            )}
            <Box padding={2} lineHeight="150%" mb={isMobile ? 0 : 10}>
              <Typography fontSize={isMobile ? 14 : 16} color="#4B5563">
                {t('common.declare_duty')}
              </Typography>
            </Box>
            {isMobile ? <FixedButtonWrapper>{renderButton()}</FixedButtonWrapper> : renderButton()}
          </Box>
        ) : (
          <Box display="flex" width="100%" justifyContent="center" height={500}>
            <Loading
              title={t('tips.empty_data', { field: '$t(glossary.test_center)' })}
              status={testCenterInfoStatus}
            />
          </Box>
        )}
      </Box>
    </>
  )
}

export default ClinicDetail
